<template>
  <div
    v-loading="loading"
    class="login-home"
    :style="{ 'background-image': `url(${themeSettings.loginBgImgUrl})` }"
  >
    <loading-animation loading-text="加载中..." :loading-show="loadingShow" />
    <!-- 左上角logo -->
    <div class="logo">
      <img :src="logoUrl">
    </div>
    <div v-if="!tenantThemeCode && isEnabledWebsite" class="official-website" @click="handleEnterWebsite">
      <img :src="monitorIcon" alt="官方网站">官方网站
      <!--<i class="iconfont icon-monitor"></i>官方网站-->
    </div>
    <!-- 网易易盾 -->
    <div ref="captcha" />
    <!-- 右上角导航 -->
    <div class="nav-bar">
      <div class="nav-bar__inner">
        <upgrade-tips-alert
          v-if="isDonotPromptUpgradeTips"
        />
        <el-dropdown v-if="hideResourceDownload" trigger="click">
          <span
            class="el-dropdown-link"
            :style="{ color: themeSettings.loginOtherElementsColor }"
          >
            <i class="icon el-icon-download" />{{ $t("resourceDownload") }}
          </span>
          <el-dropdown-menu
            slot="dropdown"
            class="download-source&#45;&#45;popper"
          >
            <el-dropdown-item>
              <div class="dropdown-download">
                <div class="icon-btn">
                  <i class="icon iconfont icon-computer" />
                </div>
                <div class="title-block">
                  <div class="title">{{ $t("systemNamePC") }}</div>
                  <div class="info" @click="downLoadPlatform">
                    {{ $t("downloadNow") }}
                  </div>
                </div>
              </div>
            </el-dropdown-item>
            <el-divider />
            <el-dropdown-item>
              <div class="dropdown-download">
                <div class="icon-btn">
                  <i class="icon iconfont icon-lifangti" />
                </div>
                <div class="title-block">
                  <div class="title">{{ $t("systemNameBIM") }}</div>
                  <div class="info">
                    <span class="bentley" @click="downLoadBentley">{{
                      $t("bentley")
                    }}</span>
                    |
                    <span class="revit" @click="downLoadRevit">{{
                      $t("revit")
                    }}</span>
                  </div>
                </div>
              </div>
            </el-dropdown-item>
            <el-divider />
            <el-dropdown-item>
              <div class="dropdown-download">
                <div class="icon-btn">
                  <i class="el-icon-mobile-phone" />
                </div>
                <div class="title-block">
                  <div class="title">{{ $t("systemNameMobile") }}</div>
                  <div class="info qrcode">{{ $t("QRCodeDownload") }}</div>
                  <div class="QRCode-img">
                    <img :src="qrCodeImgUrl">
                  </div>
                </div>
              </div>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

        <el-dropdown v-if="hideResourceDownload" trigger="click">
          <div
            class="change-language"
            :style="{ color: themeSettings.loginOtherElementsColor }"
          >
            <i class="icon iconfont icon-internet" />{{ $t("simplifiedChinese")
            }}<i class="icon el-icon-arrow-down" />
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>{{ $t("simplifiedChinese") }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>

    <!-- 主页登录 -->
    <div v-if="loginBox" class="box-card-wrap" :style="registerBox ? 'display:none;' : ''">
      <el-card
        class="box-card"
        style="padding: 56px 24px 60px 24px;"
        :style="{
          left: themeSettings.loginCardPositionX,
          top: themeSettings.loginCardPositionY,
        }"
      >
        <div class="login-title">
          <div>{{ $t("welcomeText") }}{{ systemName }}!</div>
        </div>
        <el-tabs v-if="!isMerging" v-model="activeName" style="padding: 0 24px;" @tab-click="handleClick">
          <!-- 账号密码 -->
          <el-tab-pane name="password">
            <span
              slot="label"
            ><i class="iconfont icon-lock" /> {{ $t("accountLogin") }}</span>
            <el-form
              ref="formAccount"
              class="form"
              :model="formAccount"
              :rules="rulesAccount"
            >
              <el-form-item prop="account">
                <el-input
                  ref="account"
                  v-model.trim="formAccount.account"
                  autocomplete="off"
                  :readonly="isAccountReadonly"
                  :placeholder="$t('accountPlaceholder')"
                  @keyup.enter.native="handleAccount"
                />
              </el-form-item>
              <el-form-item prop="password">
                <el-input
                  ref="accountPassword"
                  v-model.trim="formAccount.password"
                  class="captcha-block"
                  autocomplete="off"
                  :type="passwordType"
                  :placeholder="$t('passwordPlaceholder')"
                  @keyup.enter.native="accountLogin"
                >
                  <i
                    v-if="passwordType !== 'password'"
                    slot="suffix"
                    class="icon iconfont icon-eye"
                    @click="changePasswordType"
                  />
                  <i
                    v-else
                    slot="suffix"
                    class="icon iconfont icon-eye-off"
                    @click="changePasswordType"
                  />
                </el-input>
              </el-form-item>
              <el-form-item
                v-if="isShowAccountCaptchaCode"
                class="account-captchaCode"
                prop="verifyCode"
              >
                <el-col :span="17">
                  <el-input
                    ref="accountVerifyCode"
                    v-model="formAccount.verifyCode"
                    class="captcha-block"
                    :placeholder="$t('code1Placeholder')"
                    @keyup.enter.native="accountLogin"
                  />
                </el-col>
                <el-col class="line" :span="1">-</el-col>
                <el-col :span="6" class="captcha-img">
                  <img
                    :src="captchaUrlAccount"
                    style="width: 100%; height: 32px"
                    @click="setCaptchaAccount"
                  >
                </el-col>
              </el-form-item>
              <el-row type="flex" justify="space-between">
                <el-col :span="18" class="errorMsgClass">
                  {{ accountErrorMsg }}
                </el-col>
                <el-col :span="6">
                  <el-link
                    class="forget-password"
                    target="_blank"
                    :underline="false"
                    @click="forgetPassword"
                  >{{ $t("forgetPassword") }}</el-link>
                </el-col>
              </el-row>

              <div class="login-btn">
                <el-button
                  class="login-btn-mobile"
                  size="large"
                  type="primary"
                  @click="accountLogin"
                >{{ $t("login") }}</el-button>
                <el-button
                  class="register-btn-mobile"
                  size="large"
                  type="primary"
                  @click="registerAccount"
                >免费注册</el-button>
              </div>
            </el-form>
          </el-tab-pane>
          <!-- 手机号验证码 -->
          <el-tab-pane name="mobile">
            <span
              slot="label"
            ><i class="iconfont icon-smartphone" />
              {{ $t("mobileLogin") }}</span>
            <el-form
              ref="formMobile"
              class="form"
              :model="formMobile"
              :rules="rulesMobile"
            >
              <el-form-item prop="mobile">
                <el-input
                  ref="mobile"
                  v-model="formMobile.mobile"
                  autocomplete="off"
                  :placeholder="$t('mobilePlaceholder')"
                  @keyup.enter.native="handleMobile"
                />
              </el-form-item>
              <el-form-item type="flex" align="middle" justify="center" prop="verifyCode">
                <div style="display:flex;align-items: center;">
                  <el-input
                    ref="mobileVerifyCode"
                    v-model="formMobile.verifyCode"
                    style="width:240px"
                    class="captcha-block"
                    :placeholder="$t('code2Placeholder')"
                    @keyup.enter.native="mobileLogin"
                  />

                  <div style="width:18px">-</div>
                  <el-button
                    :disabled="countDown !== 60 ?(countDown>0?true:false):false"
                    class="captchInfo-btn"
                    @click="checkCaptcha"
                  >{{ captchInfo }}</el-button>
                </div>
              </el-form-item>
              <el-row>
                <el-col class="errorMsgClass">
                  {{ mobileErrorMsg }}
                </el-col>
              </el-row>
              <div class="login-btn">
                <el-button
                  class="login-btn-mobile"
                  size="large"
                  type="primary"
                  @click="mobileLogin"
                >{{ $t("login") }}</el-button>
                <el-button
                  class="register-btn-mobile"
                  size="large"
                  type="primary"
                  @click="registerAccount"
                >免费注册</el-button>
              </div>
            </el-form>
          </el-tab-pane>
        </el-tabs>
        <el-row v-else class="mergingInfo" type="flex" justify="center" align="middle">
          <p>
            <i class="el-icon-loading" /> <br>
            <span>租户信息同步中…</span>
          </p>
        </el-row>
      </el-card>
    </div>

    <!-- 已关联账号 -->
    <div v-else class="box-card-wrap">
      <el-card
        class="box-card relateAccountBox"
        :style="{
          left: themeSettings.loginCardPositionX,
          top: themeSettings.loginCardPositionY,
        }"
      >
        <div class="relate-title">
          <p> <i class="iconfont icon-arrow-left" @click="backLogin" /> {{ accountList.length>0?'已关联账号':'未关联账号' }}</p>
          <span v-show="accountList.length>0" class="aside-title">下方为已关联的账号，可直接进入</span>
        </div>
        <template v-if="accountList.length>0">
          <div class="content">
            <!--<w-scrollbar wrap-style="overflow-x: hidden;" native noresize style="height: 320px;overflow-x: hidden;">-->
            <div v-for="(item,key) of accountList" :key="key" class="content-item" @click="relatedAccountLogin(item)">
              <div class="item-left" :class="item.enterpriseId?'':'person'">
                <span class="iconfont" :class="item.enterpriseId?'icon-cmc_business':'icon-social_person'" />
              </div>
              <div class="item-middle">
                <el-popover
                  placement="bottom-start"
                  popper-class="itemPopoverClass"
                  width="300"
                  :disabled="item.enterpriseName?(item.enterpriseName.length>15?false:true):true"
                  trigger="hover"
                  :content="item.enterpriseName?(item.enterpriseName.length>15?item.enterpriseName:null):null"
                >
                  <div slot="reference" class="item-title">{{ item.enterpriseId?(item.tenantName || item.enterpriseName):'个人账号' }}</div>
                </el-popover>
                <div class="item-account">
                  <span class="item-name">
                    <template v-if="item.enterpriseId">{{ item.roleName }} </template>
                    {{ item.fullname }}
                  </span>
                </div>
              </div>
              <div class="item-right">
                <el-button type="primary" size="small" style="height: 28px;margin-top: 19px;font-size: 14px;">进入</el-button>
              </div>
            </div>
            <!--</w-scrollbar>-->
          </div>
        </template>
        <template v-else>
          <div class="unrelate-title">
            <template>
              <div class="common-txt">您的手机号 +86 {{ formMobile.mobile }}
                <br> 未关联任何广联达账号
              </div>
              <div class="common-button-box">
                <el-button class="registButton" type="primary" @click="regist">
                  快速注册
                </el-button>
                <el-button class="common-button" @click="toggleAccount">
                  使用账号密码登录
                </el-button>
              </div>
            </template>
          </div>
        </template>
      </el-card>
    </div>
    <!-- 主页注册 -->
    <div v-if="registerBox" class="box-card-wrap">
      <el-card
        class="register-box-card"
        style="padding: 56px 24px 60px 24px;"
        :style="{
          left: themeSettings.loginCardPositionX,
          top: themeSettings.loginCardPositionY,
        }"
      >
        <div class="return-title" @click="returnLogin">返回登录</div>
        <div class="login-title">
          <div>欢迎注册广联达账号</div>
        </div>
        <el-tabs v-model="registerActiveName" style="padding: 0 24px;" :style="registerActiveName==='individual'?'height: 392px;':'height: 528px;'" class="scrollbarTabsClass" @tab-click="registerHandleClick">
          <!-- 个人租户 -->
          <el-tab-pane name="individual">
            <span
              slot="label"
            >
              <svg t="1681981036709" class="icon userIcon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="22151" width="200" height="200"><path d="M682.666667 597.333333a213.333333 213.333333 0 0 1 213.12 204.074667L896 810.666667v85.333333a42.666667 42.666667 0 0 1-85.034667 4.992L810.666667 896v-85.333333a128 128 0 0 0-120.490667-127.786667L682.666667 682.666667H341.333333a128 128 0 0 0-127.786666 120.490666L213.333333 810.666667v85.333333a42.666667 42.666667 0 0 1-85.034666 4.992L128 896v-85.333333a213.333333 213.333333 0 0 1 204.074667-213.12L341.333333 597.333333h341.333334zM512 85.333333a213.333333 213.333333 0 1 1 0 426.666667 213.333333 213.333333 0 0 1 0-426.666667z m0 85.333334a128 128 0 1 0 0 256 128 128 0 0 0 0-256z" p-id="22152" /></svg>
              个人租户注册</span>
            <el-form
              ref="individualForm"
              class="form"
              :model="individualForm"
              :rules="individualRules"
              autocomplete="off"
            >
              <el-form-item prop="individualMobile" class="form-mobile-item">
                <el-input
                  ref="individualMobile"
                  v-model="individualForm.individualMobile"
                  autocomplete="off"
                  placeholder="请输入手机号"
                  @change="mobileRegisteredChange"
                />
                <div v-if="mobileRegistered" class="form-mobile-item-info">
                  <span class="form-mobile-item-text">该手机号已经注册，请</span><span class="form-mobile-item-login" @click="returnLogin">登录</span>
                </div>
              </el-form-item>
              <el-form-item type="flex" align="middle" justify="center" prop="individualVerifyCode">
                <div style="display:flex;align-items: center;">
                  <el-input
                    ref="individualVerifyCode"
                    v-model="individualForm.individualVerifyCode"
                    style="width:313px"
                    class="captcha-block"
                    autocomplete="off"
                    :placeholder="$t('code2Placeholder')"
                  />
                  <div style="width:18px">-</div>
                  <el-button
                    :disabled="countDown !== 60 ?(countDown>0?true:false):false"
                    style="width:112px"
                    class="captchInfo-btn"
                    @click="individualCheckCaptcha"
                  >{{ captchInfo }}</el-button>
                </div>
                <div v-if="enterpriseErrorCaptcha" class="form-text-item-error">
                  {{ enterpriseErrorCaptcha }}
                </div>
              </el-form-item>
              <el-form-item prop="individualPassword">
                <el-input
                  ref="individualPassword"
                  v-model="individualForm.individualPassword"
                  class="captcha-block"
                  autocomplete="new-password"
                  :type="individualPasswordType"
                  placeholder="请输入8-16位密码，数字、字母和符号至少包含两种"
                >
                  <i
                    v-if="individualPasswordType !== 'password'"
                    slot="suffix"
                    class="icon iconfont icon-eye"
                    @click="individualChangePasswordType"
                  />
                  <i
                    v-else
                    slot="suffix"
                    class="icon iconfont icon-eye-off"
                    @click="individualChangePasswordType"
                  />
                </el-input>
              </el-form-item>
              <el-form-item prop="individualPassword1">
                <el-input
                  ref="individualPassword1"
                  v-model="individualForm.individualPassword1"
                  class="captcha-block"
                  autocomplete="off"
                  :type="individualPasswordType1"
                  placeholder="确认密码"
                >
                  <i
                    v-if="individualPasswordType1 !== 'password'"
                    slot="suffix"
                    class="icon iconfont icon-eye"
                    @click="individualChangePasswordType1"
                  />
                  <i
                    v-else
                    slot="suffix"
                    class="icon iconfont icon-eye-off"
                    @click="individualChangePasswordType1"
                  />
                </el-input>
              </el-form-item>
              <el-row>
                <el-col class="errorMsgClass" style="margin-top:-5px;">
                  {{ registerErrorMsg }}
                </el-col>
              </el-row>
              <el-row>
                <el-col class="registerChecked" :style=" registerErrorMsg ? 'margin-top:0px;margin-bottom:10px;' : 'margin-top:6px;margin-bottom:15px;'">
                  <el-checkbox v-model="registerChecked" style="margin-right:5px;" />我已阅读并同意<span style="color:#4499FF;cursor: pointer;" @click="clickAgreement">《广联达用户协议》</span>和<span style="color:#4499FF;cursor: pointer;" @click="clickPrivacy">《隐私政策》</span>
                </el-col>
              </el-row>
              <el-form-item class="register-btn">
                <el-button
                  class="login-btn-mobile"
                  size="large"
                  type="primary"
                  @click="registerPerson"
                >注册</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <!-- 企业租户 -->
          <el-tab-pane name="enterprise">
            <span
              slot="label"
            >
              <svg t="1681983035028" class="icon userIcon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="22727" width="200" height="200"><path d="M538.016 64C594.336 64 640 114.144 640 176v181.44c8.32-2.912 17.152-4.736 26.368-5.28L672 352h192a96 96 0 0 1 95.84 90.368L960 448v353.248a32 32 0 0 1-63.776 3.712L896 801.28V448a32 32 0 0 0-28.256-31.776L864 416h-192a32 32 0 0 0-31.776 28.256L640 448v448h350.848c18.304 0 33.152 14.336 33.152 32s-14.848 32-33.152 32H67.776c-18.304 0-33.12-14.336-33.12-32s14.816-32 33.12-32H96V176C96 114.144 141.664 64 198.016 64h340z m3.328 64H194.656C175.52 128 160 145.184 160 166.4V896h416V166.4c0-21.216-15.52-38.4-34.656-38.4z m291.104 544a32 32 0 0 1 3.744 63.776l-3.744 0.224h-128a32 32 0 0 1-3.744-63.776l3.744-0.224h128zM480 640a32 32 0 0 1 3.744 63.776L480 704H240a32 32 0 0 1-3.744-63.776L240 640H480z m352.448-96a32 32 0 0 1 3.744 63.776l-3.744 0.224h-128a32 32 0 0 1-3.744-63.776l3.744-0.224h128zM480 448a32 32 0 0 1 3.744 63.776L480 512H240a32 32 0 0 1-3.744-63.776L240 448H480z m0-192a32 32 0 0 1 3.744 63.776L480 320H240a32 32 0 0 1-3.744-63.776L240 256H480z" p-id="22728" /></svg>
              企业租户注册</span>
            <el-scrollbar wrap-style="overflow-x: hidden;" class="scrollbarClass" style="width: 100%;overflow-x: hidden;">
              <el-form
                ref="enterpriseForm"
                class="form"
                :model="enterpriseForm"
                :rules="enterpriseRules"
              >
                <el-form-item prop="enterpriseAccount" class="form-account-item">
                  <span style="width:80px;display: inline-flex;color: #1F1F1F;font-weight: 500;font-size: 16px;line-height: 22px;">GLODON-</span>
                  <el-input
                    ref="enterpriseAccount"
                    v-model="enterpriseForm.enterpriseAccount"
                    autocomplete="off"
                    style="width:354px;margin-left: 9px;"
                    placeholder="请输入企业账号"
                  />
                  <div v-show="!enterpriseError && enterpriseAccountError" class="form-account-item-info">
                    由6-8位字母、数字、中划线和下划线组成
                  </div>
                  <div v-if="enterpriseError" class="form-account-item-error">
                    {{ enterpriseError }}
                  </div>
                </el-form-item>
                <el-form-item prop="enterpriseName">
                  <el-input
                    ref="enterpriseName"
                    v-model="enterpriseForm.enterpriseName"
                    autocomplete="off"
                    placeholder="请输入企业租户名称"
                  />
                  <div v-if="enterpriseErrorName" class="form-text-item-error">
                    企业租户名称重复
                  </div>
                </el-form-item>
                <el-form-item prop="enterpriseMobile">
                  <el-input
                    ref="enterpriseMobile"
                    v-model="enterpriseForm.enterpriseMobile"
                    autocomplete="off"
                    placeholder="请输入密保手机"
                  />
                </el-form-item>
                <el-form-item type="flex" align="middle" justify="center" prop="enterpriseVerifyCode">
                  <div style="display:flex;align-items: center;">
                    <el-input
                      ref="enterpriseVerifyCode"
                      v-model="enterpriseForm.enterpriseVerifyCode"
                      style="width:313px"
                      class="captcha-block"
                      :placeholder="$t('code2Placeholder')"
                    />
                    <div style="width:18px">-</div>
                    <el-button
                      :disabled="countDown !== 60 ?(countDown>0?true:false):false"
                      style="width:112px"
                      class="captchInfo-btn"
                      @click="enterpriseCheckCaptcha"
                    >{{ captchInfo }}</el-button>
                  </div>
                  <div v-if="enterpriseErrorCaptcha" class="form-text-item-error">
                    {{ enterpriseErrorCaptcha }}
                  </div>
                </el-form-item>
                <el-form-item prop="enterprisePassword">
                  <el-input
                    ref="enterprisePassword"
                    v-model="enterpriseForm.enterprisePassword"
                    class="captcha-block"
                    autocomplete="new-password"
                    :type="enterprisePasswordType"
                    placeholder="请输入8-16位密码，数字、字母和符号至少包含两种"
                  >
                    <i
                      v-if="enterprisePasswordType !== 'password'"
                      slot="suffix"
                      class="icon iconfont icon-eye"
                      @click="enterpriseChangePasswordType"
                    />
                    <i
                      v-else
                      slot="suffix"
                      class="icon iconfont icon-eye-off"
                      @click="enterpriseChangePasswordType"
                    />
                  </el-input>
                </el-form-item>
                <el-form-item prop="enterprisePassword1">
                  <el-input
                    ref="enterprisePassword1"
                    v-model="enterpriseForm.enterprisePassword1"
                    class="captcha-block"
                    autocomplete="off"
                    :type="enterprisePasswordType1"
                    placeholder="确认密码"
                  >
                    <i
                      v-if="enterprisePasswordType1 !== 'password'"
                      slot="suffix"
                      class="icon iconfont icon-eye"
                      @click="enterpriseChangePasswordType1"
                    />
                    <i
                      v-else
                      slot="suffix"
                      class="icon iconfont icon-eye-off"
                      @click="enterpriseChangePasswordType1"
                    />
                  </el-input>
                </el-form-item>
                <el-row>
                  <el-col class="errorMsgClass" style="margin-top:-5px;">
                    {{ registerErrorMsg }}
                  </el-col>
                </el-row>
                <el-row>
                  <el-col class="registerChecked" :style=" registerErrorMsg ? 'margin-top:0px;margin-bottom:10px;' : 'margin-top:6px;margin-bottom:15px;'">
                    <el-checkbox v-model="registerChecked" style="margin-right:5px;" />我已阅读并同意<span style="color:#4499FF;cursor: pointer;" @click="clickAgreement">《广联达用户协议》</span>和<span style="color:#4499FF;cursor: pointer;" @click="clickPrivacy">《隐私政策》</span>
                  </el-col>
                </el-row>
                <el-form-item class="register-btn">
                  <el-button
                    class="login-btn-mobile"
                    size="large"
                    type="primary"
                    @click="registerEnterprise"
                  >注册</el-button>
                </el-form-item>
              </el-form>
            </el-scrollbar>
          </el-tab-pane>
        </el-tabs>
      </el-card>
    </div>
    <!-- 主页注册成功 -->
    <div v-if="registerSuccessBox" class="box-card-wrap">
      <el-card
        class="register-success-box-card"
        style="padding: 85px 24px 60px 24px;"
        :style="{
          left: themeSettings.loginCardPositionX,
          top: themeSettings.loginCardPositionY,
        }"
      >
        <div class="register-success-title" @click="returnLogin"><div class="register-success-icon">
          <i class="el-icon-success" style="color:#00B81C;font-size: 44px;" /></div> 账号注册成功</div>
        <div class="register-success-login"> <el-button
          class="login-btn-mobile"
          style="height: 32px;padding: 0px 0px;"
          size="large"
          type="primary"
          @click="registerSuccessLogin"
        >立即登录</el-button></div>
      </el-card>
    </div>
    <el-dialog
      :title="$t('title')"
      :visible.sync="dialogVisibleInfo"
      size="mini"
    >
      <el-alert
        v-if="isShowWarningAlert"
        :title="$t('warningBoundTitle')"
        type="warning"
      />
      <div class="infoBlock">
        <!-- <i class="icon el-icon-warning"></i> -->
        <div class="content">
          <div>{{ $t("dearUsersText") }}</div>
          <i18n class="explain-content" path="dialogDescription" tag="p">
            <span
              place="agreement"
              class="info-down-middle"
              @click="goUserAgreement"
            >{{ $t("agreement") }}</span>
          </i18n>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button v-if="!isBoundMobile" type="primary" @click="goBindMobile">{{
          $t("bindNow")
        }}</el-button>
        <el-button v-else type="primary" @click="getUserInfo">{{
          $t("bound")
        }}</el-button>
      </span>
    </el-dialog>

    <template v-if="remarksFooter">
      <!-- 私有化 -->
      <footer
        class="footer"
        :style="{ color: themeSettings.loginOtherElementsColor }"
      >
        {{ remarksFooter }}
        <a
          v-if="ICPNumberText"
          href="http://beian.miit.gov.cn"
          target="_blank"
          :style="{ color: themeSettings.loginOtherElementsColor }"
        >
          {{ ICPNumberText }}
        </a>
        <a
          v-if="securityNumberText"
          :style="{ color: themeSettings.loginOtherElementsColor }"
          :href="`http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=${securityNumber}`"
          target="_blank"
        >
          {{ securityNumberText }}
        </a>
      </footer>
    </template>
    <template v-else>
      <i18n
        path="footerInfo"
        class="footer"
        tag="footer"
        :style="{ color: themeSettings.loginOtherElementsColor }"
      >
        <a
          place="ICPNumberText"
          href="http://beian.miit.gov.cn"
          target="_blank"
          :style="{ color: themeSettings.loginOtherElementsColor }"
        >
          {{ $t("ICPNumberText") }}
        </a>
        <a
          place="securityNumberText"
          :style="{ color: themeSettings.loginOtherElementsColor }"
          href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802021391"
          target="_blank"
        >
          {{ $t("securityNumberText") }}
        </a>
      </i18n>
    </template>

    <bifactor
      :page-type="pageType"
      :mobile="mobile"
      :custom-code="customCode"
      :callback-url="callbackUrl"
      :tenant-id="tenantId"
      :visible.sync="dialogVisible"
    />
    <!-- <upgrade-tips-dialog :is-donot-prompt.sync="isDonotPromptUpgradeTips"></upgrade-tips-dialog> -->
    <!-- <div style="position: absolute;">
      <iframe src="http://ebq-test.gfgwxw.top/mainv2" frameborder="0" width="0" height="0" style="opacity: 0;width: 0px;height: 0px;"></iframe>
      <iframe src="http://ebq-test.gfgwxw.top/calculate" frameborder="0" width="0" height="0" style="opacity: 0;width: 0;height: 0;"></iframe>
      <iframe src="http://qydata-qylib-test.glodon.com:7001/price/project" frameborder="0" width="0" height="0" style="opacity: 0;width: 0;height: 0;"></iframe>
    </div> -->
  </div>
</template>

<!--<i18n src="@/locales/views/home.json"></i18n>-->

<script>
// import { importEntry } from 'import-html-entry'
import Bifactor from '@/components/Bifactor'
import LoadingAnimation from '@/components/LoadingAnimation.vue'
// import UpgradeTipsDialog from '../components/UpgradeTipsDialog'
// import UpgradeTipsAlert from '../components/UpgradeTipsAlert'
import JSEncrypt from 'jsencrypt/bin/jsencrypt.min'
import { getQueryString, getCookie, getTenantThemeCodeByPath, setCookie, captchaId } from '@/utils'
import LocalStorage from '@/utils/localStorage'

const defaultBgUrl = require('@/assets/images/bg-tenant.jpg')
const staticLogoUrl = require('@/assets/images/logo.png')
const monitorIcon = require('@/assets/images/svg/monitor.svg')

// 网易易盾
let captchaIns = null
export default {
  name: 'Home',
  components: {
    Bifactor,
    LoadingAnimation
    // UpgradeTipsDialog,
    // UpgradeTipsAlert
  },
  props: {
    accountErrMsg: { type: String, default: null },
    userInfo: { type: String, default: null },
    isFromP6: { type: Boolean, default: false }
  },
  data () {
    var validatemobile = (rule, value, callback) => {
      if (value === '') {
        this.mobileValidate = false
        callback(new Error(this.$t('rulesMessage.mobile')))
      } else if (value !== '' && !/^1\d{10}$/.test(value)) {
        this.mobileValidate = false
        callback(new Error(this.$t('pleaseCorrectMobile')))
      } else {
        this.mobileValidate = true
        callback()
      }
    }

    var validatorCaptchaCode = (rule, value, callback) => {
      value = this.formAccount.account
      if (!value) {
        callback(new Error(this.$t('rulesMessage.account')))
      } else {
        callback()
      }
    }
    var validateCaptcha = (rule, value, callback) => {
      value = this.formMobile.verifyCode
      this.mobileErrorMsg = null
      if (value === '' || value === null) {
        callback(new Error('请输入短信验证码！'))
      } else if (value.length !== 6) {
        callback(new Error('短信验证码无效！'))
      } else if (isNaN(Number(value))) {
        callback(new Error('短信验证码无效！'))
      } else {
        callback()
      }
    }
    var individualValidatemobile = (rule, value, callback) => {
      if (value === '') {
        this.mobileRegisteredRules = false
        this.mobileRegistered = false
        callback(new Error(this.$t('rulesMessage.mobile')))
      } else if (value !== '' && !/^1\d{10}$/.test(value)) {
        this.mobileRegisteredRules = false
        this.mobileRegistered = false
        callback(new Error(this.$t('pleaseCorrectMobile')))
      } else {
        this.mobileRegisteredRules = true
        callback()
      }
    }
    var individualValidateCaptcha = (rule, value, callback) => {
      value = this.individualForm.individualVerifyCode
      this.mobileErrorMsg = null
      this.enterpriseErrorCaptcha = null
      if (value === '' || value === null) {
        callback(new Error('请输入短信验证码！'))
      } else if (value.length !== 6) {
        callback(new Error('短信验证码无效！'))
      } else if (isNaN(Number(value))) {
        callback(new Error('短信验证码无效！'))
      } else {
        callback()
      }
    }
    var individualValidatePassword = (rule, value, callback) => {
      const reg = /^(?:(?=.*\d)(?=.*[a-zA-Z])|(?=.*\d)(?=.*[!@#$%^&*()_+])|(?=.*[a-zA-Z])(?=.*[!@#$%^&*()_+]))[!-~]{8,16}$/
      if (/\s/g.test(value)) {
        callback(new Error('不能包含空格'))
      } else if (value === '' || value === null || !reg.test(value)) {
        callback(new Error('请输入8-16位密码，数字、字母和符号至少包含两种'))
      } else {
        callback()
      }
    }
    var enterpriseValidatePassword = (rule, value, callback) => {
      const reg = /^(?:(?=.*\d)(?=.*[a-zA-Z])|(?=.*\d)(?=.*[!@#$%^&*()_+])|(?=.*[a-zA-Z])(?=.*[!@#$%^&*()_+]))[!-~]{8,16}$/
      if (/\s/g.test(value)) {
        callback(new Error('不能包含空格'))
      } else if (value === '' || value === null || !reg.test(value)) {
        callback(new Error('请输入8-16位密码，数字、字母和符号至少包含两种'))
      } else {
        callback()
      }
    }
    var individualValidatePassword1 = (rule, value, callback) => {
      if (value === null || value !== this.individualForm.individualPassword) {
        callback(new Error('两次输入的密码不一致，请重新输入'))
      } else {
        callback()
      }
    }
    var enterpriseValidatePassword1 = (rule, value, callback) => {
      if (value === null || value !== this.enterpriseForm.enterprisePassword) {
        callback(new Error('两次输入的密码不一致，请重新输入'))
      } else {
        callback()
      }
    }
    var enterpriseValidatemobile = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密保手机'))
      } else if (value !== '' && !/^1\d{10}$/.test(value)) {
        callback(new Error(this.$t('pleaseCorrectMobile')))
      } else {
        callback()
      }
    }
    var enterpriseValidateCaptcha = (rule, value, callback) => {
      value = this.enterpriseForm.enterpriseVerifyCode
      this.mobileErrorMsg = null
      this.enterpriseErrorCaptcha = null
      if (value === '' || value === null) {
        callback(new Error('请输入短信验证码！'))
      } else if (value.length !== 6) {
        callback(new Error('短信验证码无效！'))
      } else if (isNaN(Number(value))) {
        callback(new Error('短信验证码无效！'))
      } else {
        callback()
      }
    }
    var enterpriseValidatorCaptchaCode = (rule, value, callback) => {
      value = this.enterpriseForm.enterpriseAccount
      this.enterpriseError = null
      if (!value) {
        this.enterpriseAccountError = false
        callback(new Error('请输入企业账号'))
      } else if (!/^[a-zA-Z0-9_-]{6,8}$/.test(value)) {
        this.enterpriseAccountError = false
        callback(new Error('由6-8位字母、数字、中划线和下划线组成'))
      } else {
        this.enterpriseAccountError = true
        callback()
      }
    }
    var enterpriseValidateName = (rule, value, callback) => {
      value = this.enterpriseForm.enterpriseName
      this.enterpriseErrorName = null
      if (!value) {
        callback(new Error('请输入企业租户名称'))
      } else if (/\s/g.test(value)) {
        callback(new Error('不能包含空格'))
      } else {
        callback()
      }
    }
    return {
      monitorIcon,
      loginBox: true,
      loadingShow: false, // 统一loading动画
      userType: null,
      tenantDisabled: false,
      isDonotPromptUpgradeTips: false,
      mobileValidate: false,
      dialogVisible: false,
      dialogVisibleInfo: false,
      isShowWarningAlert: false,
      loading: false,
      qrCodeImgUrl: '',
      logoUrl: '',
      systemName: '数字新成本',
      captchaUrlMobile: '',
      captchaUrlAccount: '',
      callbackUrl: '',
      isAccountReadonly: false,
      isBoundMobile: false,
      isShowAccountCaptchaCode: false,
      captchInfo: '',
      countDown: 60,
      activeName: 'password',
      // activeName: 'mobile',
      formRule: [],
      passwordType: 'password',
      pageType: '',
      mobile: '',
      customCode: '',
      bindMobileUrl: '',
      accountBaseUrl: process.env.VUE_APP_ACCOUNT_BASE_URL,
      formMobile: {
        // mobile: '18515380768',
        mobile: '',
        captchaCode: '',
        verifyCode: ''
      },
      accountData: null, // 关联账号数据
      accountList: [],
      accountErrorMsg: this.accountErrMsg, // 账号密码表单错误信息
      mobileErrorMsg: null, // 手机号表单错误信息
      isMerging: false, // 控制租户同步显示
      rulesMobile: {
        mobile: [
          { required: true, validator: validatemobile, trigger: 'blur' }
        ],
        verifyCode: [
          { required: true, validator: validateCaptcha, trigger: 'blur' },
          {
            required: true,
            message: this.$t('rulesMessage.verifyCode'),
            trigger: 'blur'
          }
        ]
      },
      rulesAccount: {
        account: [
          {
            required: true,
            validator: validatorCaptchaCode,
            trigger: ['blur', 'change']
          }
        ],
        password: [
          {
            required: true,
            message: this.$t('rulesMessage.password'),
            trigger: 'blur'
          }
        ],
        verifyCode: [
          {
            required: true,
            message: this.$t('rulesMessage.captchaCode'),
            trigger: 'blur'
          }
        ]
      },
      formAccount: {
        account: '',
        password: '',
        verifyCode: ''
      },
      themeSettings: {
        loginBgImgUrl: defaultBgUrl,
        loginOtherElementsColor: 'rgb(255, 255, 255,0.7)',
        loginCardPositionX: '50%',
        loginCardPositionY: '50%'
      },
      viewMode: 'normal',
      tenantId: '',
      hideResourceDownload: process.env.VUE_APP_NOT_ALLOWED_DOWNLOAD_RESOURCES,
      remarksFooter: process.env.VUE_APP_REMARKS_FOOTER,
      ICPNumberText: process.env.VUE_APP_ICP_NUMBER_TEXT,
      securityNumberText: process.env.VUE_APP_SECURITY_NUMBER_TEXT,
      securityNumber: process.env.VUE_APP_SECURITY_NUMBER,
      templateId: process.env.VUE_APP_FORGET_PASSWORD_TEMPLATE_ID,
      registerBox: false,
      registerSuccessBox: false,
      registerActiveName: 'individual',
      individualPasswordType: 'password',
      individualPasswordType1: 'password',
      enterprisePasswordType: 'password',
      enterprisePasswordType1: 'password',
      registerChecked: false,
      enterpriseAccountError: true,
      registerErrorMsg: null,
      enterpriseError: null,
      enterpriseErrorCaptcha: null,
      enterpriseErrorName: null,
      mobileRegistered: false,
      mobileRegisteredRules: false,
      individualForm: {
        individualMobile: '',
        individualVerifyCode: '',
        individualPassword: '',
        individualPassword1: ''
      },
      enterpriseForm: {
        enterpriseAccount: '',
        enterpriseName: '',
        enterpriseMobile: '',
        enterpriseVerifyCode: '',
        enterprisePassword: '',
        enterprisePassword1: ''
      },
      registerSuccessForm: [],
      individualRules: {
        individualMobile: [
          { required: true, validator: individualValidatemobile, trigger: 'blur' }
        ],
        individualVerifyCode: [
          { required: true, validator: individualValidateCaptcha, trigger: 'blur' },
          {
            required: true,
            message: this.$t('rulesMessage.verifyCode'),
            trigger: 'blur'
          }
        ],
        individualPassword: [
          { required: true, validator: individualValidatePassword, trigger: 'blur' },
          {
            required: true,
            message: '请输入8-16位密码，数字、字母和符号至少包含两种',
            trigger: 'blur'
          }
        ],
        individualPassword1: [
          { required: true, validator: individualValidatePassword1, trigger: 'blur' },
          {
            required: true,
            message: '确认密码',
            trigger: 'blur'
          }
        ]
      },
      enterpriseRules: {
        enterpriseAccount: [
          {
            required: true,
            validator: enterpriseValidatorCaptchaCode,
            trigger: ['blur', 'change']
          }
        ],
        enterpriseName: [
          {
            required: true,
            message: '请输入企业租户名称',
            trigger: 'blur'
          },
          { required: true, validator: enterpriseValidateName, trigger: 'blur' }
        ],
        enterpriseMobile: [
          { required: true, validator: enterpriseValidatemobile, trigger: 'blur' }
        ],
        enterpriseVerifyCode: [
          { required: true, validator: enterpriseValidateCaptcha, trigger: 'blur' },
          {
            required: true,
            message: this.$t('rulesMessage.verifyCode'),
            trigger: 'blur'
          }
        ],
        enterprisePassword: [
          { required: true, validator: enterpriseValidatePassword, trigger: 'blur' },
          {
            required: true,
            message: '请输入8-16位密码，数字、字母和符号至少包含两种',
            trigger: 'blur'
          }
        ],
        enterprisePassword1: [
          { required: true, validator: enterpriseValidatePassword1, trigger: 'blur' },
          {
            required: true,
            message: '确认密码',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  computed: {
    isPreviewMode () {
      return this.viewMode === 'preview'
    },
    tenantThemeCode () {
      return LocalStorage.getTenantThemeCode()
    }
  },
  watch: {
    'formAccount.account': {
      handler (newVal) {
        if (newVal) {
          if (
            this.currentAccount &&
            this.currentAccount !== newVal &&
            this.isShowAccountCaptchaCode
          ) {
            this.isShowAccountCaptchaCode = false
          }
          this.currentAccount = newVal
        }
      }
    },
    userInfo: {
      handler (newVal) {
        if (newVal) {
          this.formAccount.account = this.userInfo
          if (!this.isFromP6) {
            this.formAccount.password = this.userInfo
          }
        }
      },
      immediate: true
    },
    accountErrMsg: {
      handler (newVal) {
        if (newVal) {
          this.accountErrorMsg = newVal
        }
      },
      immediate: true
    }
  },
  async created () {
    this.isEnabledWebsite = !process.env.VUE_APP_WEBSITE_ENTRY_DISABLED
    if (process.env.VUE_APP_MOBILE_APP_VERSION !== 'production') {
      this.qrCodeImgUrl = require('@/assets/images/download-apk/test-qrcode.png')
    } else {
      this.qrCodeImgUrl = require('@/assets/images/download-apk/production-qrcode.png')
    }

    await this.getCustomCode()
    this.captchInfo = this.$t('getMobileCaptcha')

    // 预览模式接收消息
    const viewMode = getQueryString('viewMode')
    this.viewMode = viewMode || 'normal'
    if (this.isPreviewMode) {
      this.startListenWindowMessage()
    }
  },

  mounted () {
    // ['mainv2', 'calculate', 'archive', 'buildingside', 'constructionside', 'datascreen', 'valuationbasis'].forEach(async url => {
    //   const { getExternalScripts } = await importEntry(`https://ebq-test.gfgwxw.top/${url}/#/`)
    //   await getExternalScripts()
    // })
    // 网易盾初始化
    this.initNECaptchaDom()
  },
  methods: {
    // 跳转官方网站（产品介绍页）
    handleEnterWebsite () {
      this.sentLog(100102012)
      setTimeout(() => {
        window.location.href = `${window.location.protocol}//${window.location.host}/info`
      }, 500)
    },
    initNECaptchaDom () {
      const that = this

      window.initNECaptchaWithFallback(
        {
          element: this.$refs.captcha, // 验证码容器元素ID
          captchaId, // 由用户中心分配
          mode: 'bind',
          width: '320px',
          // protocol: 'https',
          // staticServer: 'localhost:8091',
          onVerify (err, data) {
            console.log(err,data)
            if (err) return // 当验证失败时，内部会自动refresh方法，无需手动再调用一次
            // 用户验证码验证成功后，进行实际的提交行为
            if (data) {
              console.log(data)
              if(that.activeName !== 'password'){
                that.verifyCallback({ validate: data.validate, captchaId })
              }else{
                that.getAccountType(that.formAccount.account)
              }
            }
          }
        },
        (instance) => {
          // 初始化成功后得到验证实例instance，可以调用实例的方法
          captchaIns = instance
        },
        (err) => {
          // 初始化失败后触发该函数，err对象描述当前错误信息
          console.log('i err', err)
        }
      )
    },
    // 网易易盾验证成功回调
    verifyCallback (verifyOptions = {}) {
      captchaIns && captchaIns.refresh()
      // 获取短信
      const captchaCode = verifyOptions.validate
      this.getCaptcha(captchaCode)
    },
    startListenWindowMessage () {
      window.addEventListener('message', (evt) => {
        const data = evt.data
        if (data) {
          if (Object.prototype.hasOwnProperty.call(data, 'loginBgImgUrl')) {
            this.themeSettings.loginBgImgUrl =
              data.loginBgImgUrl || defaultBgUrl
          }
          if (
            Object.prototype.hasOwnProperty.call(
              data,
              'loginOtherElementsColor'
            )
          ) {
            this.themeSettings.loginOtherElementsColor =
              data.loginOtherElementsColor || '#FFFFFF'
          }
          if (
            Object.prototype.hasOwnProperty.call(data, 'loginCardPositionX')
          ) {
            this.themeSettings.loginCardPositionX =
              data.loginCardPositionX || '50%'
          }
          if (
            Object.prototype.hasOwnProperty.call(data, 'loginCardPositionY')
          ) {
            this.themeSettings.loginCardPositionY =
              data.loginCardPositionY || '50%'
          }
        }
      })
    },
    handleClick (data) {
      const mobile = this.formMobile.mobile
      this.accountErrorMsg = null
      this.mobileErrorMsg = null
      if (data.name === 'mobile') {
        this.resetForm('formMobile')
        this.formMobile.mobile = mobile
        this.sentLog('100101002')
      } else {
        this.isShowAccountCaptchaCode = false
        this.resetForm('formAccount')
        this.sentLog('100101001')
      }
    },
    // 切换个人注册和企业注册
    registerHandleClick (data) {
      if (data.name === 'individual') {
        this.resetForm('individualForm')
        this.sentLog('100101017')
      } else {
        this.resetForm('enterpriseForm')
        this.enterpriseAccountError = true
        this.sentLog('100101018')
      }
      this.mobileRegistered = false
      this.mobileRegisteredRules = false
      this.registerErrorMsg = null
      this.registerChecked = false
      this.enterpriseError = null
      this.enterpriseErrorCaptcha = null
      this.enterpriseErrorName = null
    },
    resetForm (formName) {
      if (this.$refs[formName] !== undefined) {
        this.$refs[formName].resetFields()
      }
    },
    changePasswordType () {
      this.passwordType =
        this.passwordType === 'password' ? 'text' : 'password'
    },
    individualChangePasswordType () {
      this.individualPasswordType =
        this.individualPasswordType === 'password' ? 'text' : 'password'
    },
    individualChangePasswordType1 () {
      this.individualPasswordType1 =
        this.individualPasswordType1 === 'password' ? 'text' : 'password'
    },
    enterpriseChangePasswordType () {
      this.enterprisePasswordType =
        this.enterprisePasswordType === 'password' ? 'text' : 'password'
    },
    enterpriseChangePasswordType1 () {
      this.enterprisePasswordType1 =
        this.enterprisePasswordType1 === 'password' ? 'text' : 'password'
    },
    forgetPassword () {
      this.sentLog('100101003')
      // const homeUrl = this.callbackUrl
      const homeUrl = `${window.location.origin}/`
      const accountUrl =
        this.accountBaseUrl +
        `/forgetInit?templateId=Ccl72S2MG946P1Imxoxy9IwBL0qamxci&returnTo=${homeUrl}`
      // // 私有化
      // if (this.templateId) {
      //   accountUrl = accountUrl + '&smsTemplateId=' + this.templateId
      // }
      window.location.href = accountUrl
    },

    downLoadPlatform () {
      window.location.href =
        'https://cloudt-product-vpc-pub.oss-cn-beijing.aliyuncs.com/bim5d-client/glodon_product_launcher_installer.exe'
    },
    // 下载BIM插件-Bentley
    downLoadBentley () {
      window.location.href =
        'https://cloudt-product-vpc-pub.oss-cn-beijing.aliyuncs.com/bim5d-client/glodon_microstation_igms_plugin.exe'
    },
    // 下载BIM插件-Revit
    downLoadRevit () {
      window.location.href =
        'https://cloudt-product-vpc-pub.oss-cn-beijing.aliyuncs.com/bim5d-client/glodon_revit_igms_plugin.exe'
    },
    goUserAgreement () {
      window.open(this.accountBaseUrl + '/agreement')
    },
    goBindMobile () {
      this.isBoundMobile = true
      this.isShowWarningAlert = false
      window.open(this.bindMobileUrl)
    },
    async getCustomCode () {
      this.callbackUrl = getQueryString('callbackUrl') || getQueryString('redirectUrl', getCookie('.CLOUD.DEVCENTER.REDIRECT.URL')) || `${window.location.origin}/portal/`
      this.customCode = LocalStorage.getTenantThemeCode() || (this.callbackUrl && getTenantThemeCodeByPath(this.callbackUrl))
      if (this.customCode) {
        this.loading = true

        await this.getLoginLogos().catch(() => {
          this.loading = false
        })
        await this.getLoginThemeSetting().catch(() => {
          this.loading = false
        })

        this.loading = false
      } else {
        this.logoUrl = staticLogoUrl
        this.systemName = this.$t('systemName')
      }
    },
    async getLoginLogos () {
      const res = await this.$api.home.getLoginLogos(this.customCode)

      this.logoUrl = res.logoUrl || staticLogoUrl
      this.systemName = res.systemName && res.systemName !== '数字项目管理平台' ? res.systemName : this.$t('systemName')
      this.tenantId = res.tenantId || ''
      this.tenantDisabled = res.tenantDisabled
    },
    async getLoginThemeSetting () {
      const params = {}
      params.customCode = this.customCode
      const loginThemeSetting = await this.$api.home.getLoginThemeSetting(
        params
      )
      this.themeSettings.loginBgImgUrl =
        loginThemeSetting.loginBgImgUrl || defaultBgUrl
      this.themeSettings.loginOtherElementsColor =
        loginThemeSetting.loginOtherElementsColor || '#FFFFFF'
      this.themeSettings.loginCardPositionX =
        loginThemeSetting.loginCardPositionX || '50%'
      this.themeSettings.loginCardPositionY =
        loginThemeSetting.loginCardPositionY || '50%'
    },
    // 1.1获取手机号验证码
    async checkCaptcha () {
      this.mobileErrorMsg = null
      await this.$refs.formMobile.clearValidate('verifyCode')
      await this.$refs.formMobile.validateField('mobile')
      const reg = /^1[3456789]{1}\d{9}$/
      if (!reg.test(this.formMobile.mobile)) {
        return
      }
      captchaIns && captchaIns.verify()
    },
    // 个人注册获取手机号验证码
    async individualCheckCaptcha () {
      this.mobileErrorMsg = null
      await this.$refs.individualForm.clearValidate('individualVerifyCode')
      await this.$refs.individualForm.validateField('individualMobile')
      const reg = /^1[3456789]{1}\d{9}$/
      if (!reg.test(this.individualForm.individualMobile)) {
        return
      }
      if (this.mobileRegisteredRules) {
        this.$api.home.registerUsed({
          mobile: this.individualForm.individualMobile
        })
          .then(res => {
            if (res.code === 200) {
              if (res.data?.used) {
                this.mobileRegistered = true
              } else {
                this.mobileRegistered = false
                captchaIns && captchaIns.verify()
              }
            } else {
              this.mobileRegistered = false
              this.registerErrorMsg = res.message
            }
          }).catch(e => { console.log(e) })
      }
    },
    // 企业注册获取手机号验证码
    async enterpriseCheckCaptcha () {
      this.mobileErrorMsg = null
      await this.$refs.enterpriseForm.clearValidate('enterpriseVerifyCode')
      await this.$refs.enterpriseForm.validateField('enterpriseMobile')
      const reg = /^1[3456789]{1}\d{9}$/
      if (!reg.test(this.enterpriseForm.enterpriseMobile)) {
        return
      }
      captchaIns && captchaIns.verify()
    },
    async getCaptcha (captchaCode) {
      this.mobileErrorMsg = null
      const param = {
        mobile: this.formMobile.mobile,
        captchaCode,
        captchaId
      }
      if (this.registerBox) {
        if (this.registerActiveName === 'individual') {
          param.mobile = this.individualForm.individualMobile
        } else {
          param.mobile = this.enterpriseForm.enterpriseMobile
        }
        const res = await this.$api.home.getRegisterCaptcha(param)
        if (res.code === 200) {
          this.$message({
            message: '验证码发送成功',
            type: 'success'
          })
          this.setVerifyCodeTime()
        } else {
          this.registerErrorMsg = res.message || '获取验证码失败'
        }
      } else {
        const res = await this.$api.home.getCaptcha(param)
        if (res.code === 200) {
          this.$message({
            message: '验证码发送成功',
            type: 'success'
          })
          this.setVerifyCodeTime()
        } else {
          this.mobileErrorMsg = res.message || '获取验证码失败'
        }
      }
    },
    async mobileLogin () {
      await this.$refs.formMobile.validate()

      this.getMobileRelationAccount(this.formMobile.verifyCode)
    },
    backLogin(){
      this.loginBox = true
      captchaIns && captchaIns.refresh()
    },
    // 1.2根据手机号、短信验证码获取关联账号列表
    async getMobileRelationAccount (captcha) {
      this.loadingShow = true
      const { mobile } = this.formMobile
      const res = await this.$api.home.getMobileRelationAccount({
        mobile,
        verifyCode: captcha
      })
      if (res.code === 200) {
        this.accountData = res.data
        if (res.data.accountList.length === 1) {
          this.relatedAccountLogin(res.data.accountList[0])
        } else {
          this.loginBox = false
          this.accountList = res.data.accountList
        }
      } else {
        this.mobileErrorMsg = res.message
        this.sentLog('100101005', { result: '失败', reason: '验证码错误', mobile, code: res.code })
      }
      this.loadingShow = false
    },
    // 1.3关联账号登录
    async relatedAccountLogin (item) {
      this.loadingShow = true
      // 手机号验证码登录判断是否需要加载页
      this.$api.home.mobileLoadPage({
        sign: this.accountData.sign,
        gldUserId: item.id
      })
        .then(res => {
          if (res.code === 200) {
            if (res.data.load) {
              this.loadingShow = false
              this.loginBox = true
              this.isMerging = true
            }
          } else {
            this.mobileErrorMsg = res.message
          }
        }).catch(e => { console.log(e) })
      const res = await this.$api.home.getMobileInfo({
        sign: this.accountData.sign,
        gldUserId: item.mainGldUserId || item.id,
        tenantId: item.tenantId || ''
      })
      if (res.code === 200) {
        const { geipToken, gldToken, tenantId, passwordMobile, authEnterpriseId, roleId } = res.data
        sessionStorage.setItem('dcost-user-info', JSON.stringify(res.data))
        this.userType = item.roleId
        localStorage.setItem('isBindPhone', passwordMobile ? 'true' : 'false')
        // 进系统
        this.loadingShow = false
        this.isMerging = false
        this.$emit('login', geipToken, gldToken, (item.mainGldUserId || item.id), tenantId, authEnterpriseId, roleId)
      } else {
        const { mobile } = this.formMobile
        this.sentLog('100101005', { result: '失败', reason: '关联列表登录失败', mobile, code: res.code, gldUserId: item.id })
        this.$message.error(res.message)
      }
      this.loadingShow = false
      this.isMerging = false
    },
    // 快速注册
    async regist () {
      this.loadingShow = true
      const res = await this.$api.home.regist({
        mobile: this.formMobile.mobile,
        verifyCode: this.formMobile.verifyCode
      })
      if (res.code === 200) {
        const result = await this.$api.home.getMobileInfo({
          sign: res.data.sign,
          gldUserId: res.data.accountInfo.id
        })
        if (result.code === 200) {
          const { geipToken, gldToken, tenantId, passwordMobile, authEnterpriseId, roleId } = result.data
          localStorage.setItem('dcost-user-info', JSON.stringify(res.data))
          this.loginBox = true
          this.isMerging = true
          this.$message({
            message: '账号注册成功！',
            type: 'success'
          })
          this.userType = res.data.accountInfo.roleId
          localStorage.setItem('isBindPhone', passwordMobile ? 'true' : 'false')
          this.setAccountType(geipToken, 1)
          // 进系统
          this.$emit('login', geipToken, gldToken, res.data.accountInfo.id, tenantId, authEnterpriseId, roleId)
        } else {
          this.$message.error(result.message)
        }
      } else {
        this.$message.error(res.message)
      }
      this.loadingShow = false
    },
    setVerifyCodeTime () {
      const timeoutId = setInterval(() => {
        this.countDown--
        this.captchInfo = '- ' + this.countDown + 's'
        if (this.countDown < 1) {
          clearInterval(timeoutId)
          this.captchInfo = this.$t('getMobileCaptcha')
          this.countDown = 60
        }
      }, 1000)
    },
    // 切换登录
    toggleAccount () {
      this.loginBox = true
      this.accountErrMsg = null
      this.mobileErrorMsg = null
      this.activeName = 'password'
    },
    async getUserInfo () {
      const res = await this.$api.home.getUserInfo()

      if (res.code === 200) {
        this.isBindMobile(res.data, 'checkAuthenticityDialog')
      } else {
        this.$message.error(res.errorMsg)
      }
    },
    handleMobile () {
      if (this.formMobile.mobile) {
        this.$refs.mobile.blur()
        this.$nextTick(() => {
          if (!this.mobileValidate) {
            this.$refs.mobile.focus()
          } else {
            if (!this.formMobile.captchaCode) {
              this.$refs.mobileCaptchaCode.focus()
            } else {
              !this.formMobile.verifyCode
                ? this.$refs.mobileVerifyCode.focus()
                : this.mobileLogin()
            }
          }
        })
      } else {
        this.$refs.mobile.blur()
        this.$refs.mobile.focus()
      }
    },

    handleAccount () {
      if (this.formAccount.account) {
        if (!this.formAccount.password) {
          this.$refs.accountPassword.focus()
        } else {
          this.accountLogin()
        }
      } else {
        this.$refs.account.blur()
        this.$refs.account.focus()
      }
    },
    encryptPassword (password) {
      var encryptor = new JSEncrypt() // 创建加密对象实例
      var pubKey = `
          -----BEGIN PUBLIC KEY-----
          MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQC+bcL+CNi4df/GWrXHymDhJDQa
          wHcaJC1U1u1eMqUNMTDWCtS0hyYc+HqvXtW7dOnqxQabDd1fOBdEFru8QE8cT4jM
          DJov2AWZ/Q/M2SA4WBqr9lCRodQYxxGtA/z/deamqPHX4JtRSRkFn0B96CF2ovFc
          uzoTDGCQ9A3KReW/ewIDAQAB
          -----END PUBLIC KEY-----
        `
      encryptor.setPublicKey(pubKey) // 设置公钥
      return encryptor.encrypt(password)
    },
    // 1.1账号密码登录
    async accountLogin () {
      await this.$refs.formAccount.validate()
      this.accountErrorMsg = null
      captchaIns && captchaIns.verify()
      // await this.getAccountType(this.formAccount.account)
    },

    // 1.2查询账号类型和同步状态
    async getAccountType (accountName) {
      const res = await this.$api.home.getAccountType(accountName)
      if (res.code === 200) {
        this.accountType(res.data.accountType, res.data.status)
      } else {
        this.passwordLogin()
      }
    },
    accountType (type, status) {
      // 账号类型：0 账号不存在 1 个人账号，2：企业账号，3：VIP账号
      switch (type) {
        case 0:
          this.accountErrorMsg = '账户不存在！'
          break
        case 1:
        case 2:
        case 3:
          this.passwordLogin(type, status)
          break
        // case 3:
        //   this.accountErrorMsg = '暂不支持该账号登录，请前往相关产品入口登录!'
        //   break
        default:
          break
      }
    },
    // 1.3调用账号密码登录查询接口
    passwordLogin (type, status) {
      this.loadingShow = true
      const { account, password } = this.formAccount
      const loadPageData = {
        account,
        password: this.encryptPassword(password)
      }
      const formData = {
        account,
        force: true,
        password: this.encryptPassword(password)
      }
      if (this.registerSuccessBox) {
        loadPageData.account = this.registerSuccessForm.account
        loadPageData.password = this.registerSuccessForm.password
        formData.account = this.registerSuccessForm.account
        formData.password = this.registerSuccessForm.password
      }
      this.$api.home.loadPage(loadPageData)
        .then(res => {
          if (res.code === 200) {
            if (res.data.load) {
              this.loadingShow = false
              this.isMerging = true
              this.registerBox = false
              this.registerSuccessBox = false
            }
          } else {
            this.accountErrorMsg = res.message
            captchaIns && captchaIns.refresh()
          }
        }).catch(e => { console.log(e) })
      this.$api.home.accountLogin(formData)
        .then(res => {
          this.isMerging = false
          this.loadingShow = false
          if (res.code === 200) {
            const { geipToken, gldToken, gldUserId, tenantId, passwordMobile, relationAccountInfo, authEnterpriseId, roleId } = res.data
            sessionStorage.setItem('dcost-user-info', JSON.stringify(res.data))
            // 手机号密码登录 - start
            if (relationAccountInfo) {
              this.accountData = relationAccountInfo
              if (Array.isArray(relationAccountInfo.accountList)) {
                this.loginBox = false
                this.registerBox = false
                this.registerSuccessBox = false
                this.accountList = relationAccountInfo.accountList
              }
              return
            }
            // 手机号密码登录 - end
            this.userType = res.data.roleId || ''
            if (type === 1 && status === 0) {
              this.isMerging = true
              this.registerBox = false
              this.registerSuccessBox = false
              this.setAccountType(geipToken, 1)
                .then(() => {
                  localStorage.setItem('isBindPhone', passwordMobile ? 'true' : 'false')
                  setCookie('gldToken', gldToken)
                  this.$emit('login', geipToken, gldToken, gldUserId, tenantId, authEnterpriseId, roleId)
                })
                .catch(e => {
                  this.$message.error(e)
                })
            } else {
              localStorage.setItem('isBindPhone', passwordMobile ? 'true' : 'false')
              setCookie('gldToken', gldToken)
              this.$emit('login', geipToken, gldToken, gldUserId, tenantId, authEnterpriseId, roleId)
              this.registerBox = false
              this.registerSuccessBox = false
            }
          } else if (res.code === 200007) {
            // 成本范围外用户
            this.accountErrorMsg = '暂不支持该账号登录，请前往相关产品入口登录！'
            this.sentLog('100101004', { result: '失败', reason: '成本外账号无法登陆', account })
          } else if ([100006, 300001, 400001, 500001].includes(res.code)) {
            this.accountErrorMsg = '服务异常！'
            this.sentLog('100101004', { result: '失败', reason: '服务异常！', account })
          } else if ([200001, 200006].includes(res.code)) {
            this.accountErrorMsg = '用户名或密码错误！'
            this.sentLog('100101004', { result: '失败', reason: '账号密码错误', account })
          } else {
            this.accountErrorMsg = res.message
            this.sentLog('100101004', { result: '失败', reason: '接口调用失败', account })
          }
          captchaIns && captchaIns.refresh()
          this.registerBox = false
          this.registerSuccessBox = false
          // this.loadingShow = false
        })
        .catch((e) => {
          captchaIns && captchaIns.refresh()
          this.isMerging = false
          this.loadingShow = false
          this.registerBox = false
          this.registerSuccessBox = false
          if (type === 1) this.accountErrorMsg = '租户信息同步失败，请稍后重试！'
          if (type === 2) this.accountErrorMsg = '暂不支持该账号登录，请前往相关产品入口登录！'
          this.sentLog('100101004', { result: '失败', reason: '接口调用失败', account })
        })
    },
    // 设置账号同步状态
    setAccountType (geipToken, status) {
      return new Promise((resolve, reject) => {
        this.$api.home.setAccountType(geipToken, status)
          .then(res => {
            if (res.code === 200) {
            // 同步成功
              resolve(true)
            } else {
              this.accountErrorMsg = res.message
              reject(new Error(res.message))
            }
            this.isMerging = false
          })
          .catch((e) => {
            this.isMerging = false
            this.accountErrorMsg = '租户信息同步失败，请稍后重试！'
            reject(new Error('租户信息同步失败，请稍后重试！'))
          })
      })
    },
    // 免费注册
    registerAccount () {
      this.registerBox = true
      this.registerActiveName = 'individual'
      this.registerErrorMsg = null
      this.enterpriseError = null
      this.enterpriseErrorCaptcha = null
      this.enterpriseErrorName = null
      this.enterpriseAccountError = true
      this.registerSuccessBox = false
      this.registerSuccessForm = []
      this.registerChecked = false
      this.mobileRegistered = false
      this.mobileRegisteredRules = false
      this.$nextTick(() => {
        this.resetForm('individualForm')
        this.resetForm('enterpriseForm')
      })
      this.sentLog(100101016)
    },
    // 返回登录
    returnLogin () {
      this.registerBox = false
      this.registerSuccessBox = false
      this.resetForm('individualForm')
      this.resetForm('enterpriseForm')
    },
    // 个人租户注册
    async registerPerson () {
      await this.$refs.individualForm.validate()
      if (!this.registerChecked) {
        this.registerErrorMsg = '请阅读并同意以下协议'
      } else {
        this.registerErrorMsg = null
        const { individualMobile, individualVerifyCode, individualPassword, individualPassword1 } = this.individualForm
        const params = {
          mobile: individualMobile,
          verifyCode: individualVerifyCode,
          password: this.encryptPassword(individualPassword),
          confirmPassword: this.encryptPassword(individualPassword1)
        }
        this.loadingShow = true
        this.$api.home.registerPerson(params)
          .then(res => {
            this.loadingShow = false
            if (res.code === 200) {
              this.loadingShow = false
              this.registerSuccessBox = true
              this.registerSuccessForm = res.data
              this.sentLog('100101021', { result: '成功' })
              this.resetForm('individualForm')
              this.registerErrorMsg = null
            // 注册成功
            } else {
              this.loadingShow = false
              this.registerErrorMsg = res.message
              this.sentLog('100101021', { result: '失败', reason: res.message })
            }
          })
          .catch((e) => {
            this.loadingShow = false
            this.registerErrorMsg = '注册失败，请稍后重试！'
            this.sentLog('100101021', { result: '失败', reason: '接口调用失败' })
          })
      }
    },
    // 企业租户注册
    async registerEnterprise () {
      await this.$refs.enterpriseForm.validate()
      if (!this.registerChecked) {
        this.registerErrorMsg = '请阅读并同意以下协议'
      } else {
        this.registerErrorMsg = null
        const { enterpriseAccount, enterpriseName, enterpriseMobile, enterpriseVerifyCode, enterprisePassword, enterprisePassword1 } = this.enterpriseForm
        const params = {
          account: enterpriseAccount,
          enterpriseTenantName: enterpriseName,
          mobile: enterpriseMobile,
          verifyCode: enterpriseVerifyCode,
          password: this.encryptPassword(enterprisePassword),
          confirmPassword: this.encryptPassword(enterprisePassword1)
        }
        this.loadingShow = true
        this.$api.home.registerEnterprise(params)
          .then(res => {
            this.loadingShow = false
            if (res.code === 200) {
              this.loadingShow = false
              this.registerSuccessBox = true
              this.registerSuccessForm = res.data
              this.resetForm('enterpriseForm')
              this.registerErrorMsg = null
              this.enterpriseError = null
              this.enterpriseErrorCaptcha = null
              this.enterpriseErrorName = null
              this.sentLog('100101021', { result: '成功' })
            // 注册成功
            } else if (res.code === 500020) {
              this.enterpriseError = '管理员账号重复'
              this.sentLog('100101021', { result: '失败', reason: this.enterpriseError })
            } else if (res.code === 500016) {
              this.enterpriseErrorCaptcha = '验证码无效'
              this.sentLog('100101021', { result: '失败', reason: this.enterpriseErrorCaptcha })
            } else if (res.code === 500023) {
              this.enterpriseErrorName = '企业租户名称重复'
              this.sentLog('100101021', { result: '失败', reason: this.enterpriseErrorName })
            } else {
              this.registerErrorMsg = res.message
              this.sentLog('100101021', { result: '失败', reason: res.message })
            }
          })
          .catch((e) => {
            this.registerErrorMsg = null
            this.enterpriseError = null
            this.enterpriseErrorCaptcha = null
            this.enterpriseErrorName = null
            this.loadingShow = false
            this.registerErrorMsg = '注册失败，请稍后重试！'
            this.sentLog('100101021', { result: '失败', reason: '接口调用失败' })
          })
      }
    },
    // 注册成功登录
    async registerSuccessLogin () {
      await this.getAccountType(this.registerSuccessForm.account)
    },
    clickAgreement () {
      this.sentLog('100101019')
      window.open(`${window.location.protocol}//${window.location.host}/info/#/agreement`, '_blank')
    },
    clickPrivacy () {
      this.sentLog('100101020')
      window.open(`${window.location.protocol}//${window.location.host}/info/#/privacy`, '_blank')
    },
    // 验证手机号是否已注册
    async mobileRegisteredChange (value) {
      await this.$refs.individualForm.validateField('individualMobile')
      if (this.mobileRegisteredRules) {
        this.$api.home.registerUsed({
          mobile: value
        })
          .then(res => {
            if (res.code === 200) {
              if (res.data?.used) {
                this.mobileRegistered = true
              } else {
                this.mobileRegistered = false
              }
            } else {
              this.mobileRegistered = false
              this.registerErrorMsg = res.message
            }
          }).catch(e => { console.log(e) })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";
.login-home {
  background-position: bottom right;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  width: 100%;
  height: 100vh;
  .forget-password {
    float: right;
  }
  .logo {
    position: absolute;
    left: 36px;
    top: 24px;
    img {
      height: 40px;
      width: auto;
      /*width: 259px;*/
    }
  }
  .official-website {
    position: absolute;
    right: 50px;
    top: 33px;
    color: #FFF;
    font-size: 16px;
    font-weight: 400;
    height: 22px;
    line-height: 22px;
    cursor: pointer;
    img {
      height: 22px;
      width: 22px;
      vertical-align: middle;
      margin-right: 4px;
    }
  }
  .mergingInfo{
    height: 390px;
    p{
      margin: 0;
      text-align: center;
    }
    i{
      font-size: 24px;
      color: #4499FF;
    }
    span{
      display: block;
      font-size: 14px;
      color: rgba(31, 31, 31, 0.8);
      font-family: PingFangSC-Regular, PingFang SC;
    }
  }
  ::v-deep .el-tabs {
    height: 310px;
  }
  ::v-deep .el-tabs__content {
    position: static;
    overflow: visible;
  }
  ::v-deep .el-card {
    box-sizing: border-box;
    min-height: 540px;
    padding: 56px 48px 60px 48px;
    z-index: 99;
  }
  ::v-deep .el-card__body {
    padding: 0px;
    // width: 360px;
  }
  ::v-deep .el-tabs--top {
    margin-top: 48px;
  }
  ::v-deep div.el-input.el-input--small {
    font-size: 14px;
    height: 44px;
    line-height: 44px;
  }

  ::v-deep .el-input--small .el-input__inner {
    height: 44px;
    line-height: 44px;
    padding: 0 16px;
    font-size: 16px;
    &::placeholder{
      font-size: 16px;
      color: rgba(31,31,31,0.35);
    }
    // &:-webkit-autofill{
    //   font-size: 16px;
    //   transition: background-color 100s ease-in-out 0s;
    // }
  }
  ::v-deep .el-input--small .el-input__suffix{
    height: 44px !important;
    right: 9px !important;
    display: flex;
    align-items: center;
  }
  ::v-deep .el-form-item__error {
    color: #fa2a31;
    font-size: 12px;
    line-height: 1;
    padding-top: 4px;
    position: absolute;
    top: 44px;
    left: 0px;
  }
  ::v-deep form.el-form .el-form-item,
  form.el-form .el-form-item--small {
    margin-bottom: 24px;
  }
  ::v-deep .el-divider--horizontal {
    margin: 6px 0 !important;
  }
  ::v-deep .el-tabs__header {
    margin-bottom: 40px;
  }
  ::v-deep button.el-button.el-button--small {
    height: 44px;
  }
  .el-link.el-link--default {
    color: rgba(31, 31, 31, 0.55);
  }
  .nav-bar {
    position: absolute;
    top: 32px;
    right: 34px;
    font-size: 14px;
    // color: $--color-text-regular;
    .nav-bar__inner {
      margin-right: 30px;
      ::v-deep .el-dropdown {
        margin-right: 24px;
      }
      ::v-deep .el-dropdown-link,
      .change-language {
        cursor: pointer;
      }
    }
    .icon {
      font-size: 14px;
      margin-left: 5px;
      margin-right: 5px;
    }
  }
  .national-flag {
    width: 16px;
    height: 16px;
    border-radius: 8px;
    position: relative;
    top: 3px;
  }
  .el-alert {
    margin-bottom: 12px;
  }
  .captcha-img {
    cursor: pointer;
    height: 44px;
  }
  .errorMsgClass{
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #EC261D;
  }
  .footer {
    position: absolute;
    bottom: 29px;
    width: 100%;
    text-align: center;
    font-size: 12px;
    line-height: 20px;
    a {
      text-decoration: none;
      padding-left: 8px;
    }
  }
  .login-btn {
    position: absolute;
    bottom: 20px;
    width: 360px;
  }
  .register-btn {
    // position: absolute;
    // bottom: 5px;
    width: 444px;
  }
  .login-btn-mobile {
    width: 100%;
    color: #ffffff;
    background-color: #4499ff;
    border-color: #4499ff;
    height: 48px;
    font-size: 16px;
  }
  .login-btn-mobile:hover {
    background-color: #2288ff;
    border-color: #2288ff;
  }

  .login-btn-mobile:focus {
    background-color: #0f71e4;
    border-color: #0f71e4;
  }
  .register-btn-mobile {
    width: 100%;
    color: rgba(31,31,31,0.8);
    line-height: 24px;
    background: #FFFFFF;
    border-radius: 4px;
    border: 1px solid #DEDEDE;
    height: 48px;
    margin:16px 0px;
    font-weight: 500;
    font-size: 16px;
  }
  .register-btn-mobile:hover {
    background: rgba(68,153,255,0.15);
    border: 1px solid #4499FF;
  }

  .register-btn-mobile:focus {
    background: rgba(68,153,255,0.3);
    border: 1px solid #4499FF;
  }
  .account-captchaCode {
    margin-bottom: 0px;
  }
  .captcha-block .icon {
    // color: $--color-text-regular;
  }
  ::v-deep .el-tabs__item {
    padding: 0 18px;
  }
}
.line {
  // padding-left: 4px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.text {
  font-size: 14px;
}
.item {
  padding: 18px 0;
}
.box-card {
  width: 456px;
  position: absolute;
  transform: translate(-50%, -50%);
  .login-title {
    font-size: 24px;
    font-weight: 600;
    line-height: 32px;
    text-align: center;
  }
  .relate-title{
    font-size: 24px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 300;
    color: #1F1F1F;
    line-height: 1;
    margin-top: 48px;
    margin-left: 48px;
    p{
      margin: 0;
      line-height: 32px;
    }
    i{
      font-size: 24px;
      cursor: pointer;
      color: rgba(31, 31, 31, 0.55);
    }
    span{
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: rgba(31, 31, 31, 0.55);
      line-height: 24px;
    }
  }
  .content{
    margin-top: 20px;
    height: 320px;
    overflow-x: auto;
    .content-item{
      &:first-child{
        margin-top: 0;
      }
      &:hover{
        border: 1px solid #4499FF;
      }
      height: 66px;
      border-radius: 4px;
      border: 1px solid rgba(33,37,48,.15);
      box-sizing: border-box;
      margin-top: 12px;
      display: flex;
      .item-left{
        display: flex;
        align-items: center;
        justify-content: center;
        width: 40px;
        margin: 12px;
        border-radius: 50%;
        background: #4499FF;
        color: #fff;
        .iconfont{
          display: inline-block;
          font-size: 24px;
        }
        &.person{
          background: #23BC8D;
        }
      }
      .item-middle{
        flex: 1;
        padding-right: 12px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        .item-title{
          font-size: 14px;
          color: #212530;
          line-height: 22px;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
        .item-account{
          font-size: 12px;
          color: rgba(33,37,48,.55);
          line-height: 20px;
        }

      }
      .item-right{
        width: 56px;
        padding-left: 12px;
        padding-right: 12px;
        .el-button{
          background: #4499FF;
          border-radius: 4px;
          padding-left: 14px;
          padding-right: 14px;
          border:none !important;
          &:hover{
            background-color: #2288ff !important;
          }
          &:active{
            background-color: #0f71e4 !important;
          }
        }
      }
    }
  }
  .unrelate-title{
    padding: 88px 84px 0;
    .common-txt{
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(31, 31, 31, 0.8);
      line-height: 36px;
      text-align: center;
    }
    .common-button-box{
      margin-top: 60px;
      display: flex;
      flex-direction: column;
      .registButton{
        font-size: 16px !important;
        background: #4499FF !important;
        &:hover{
          background: #2288FF !important;
        }
        &:active{
          background: #0F71E4 !important;
        }
      }
      .common-button{
        margin-left: 0;
        margin-top: 24px;
        font-size: 16px !important;
        &:hover{
          color: rgba(31, 31, 31, 0.8) !important;
          background: rgba(68, 153, 255, 0.15) !important;
        }
        &:active{
          color: rgba(31, 31, 31, 0.8) !important;
          background: rgba(68, 153, 255, 0.3) !important;
        }
      }
    }
  }
}
.register-box-card {
  width: 542px;
  position: absolute;
  transform: translate(-50%, -50%);
  z-index: 101;
  .return-title {
    font-size: 14px;
    font-weight: 400;
    color: rgba(31,31,31,0.8);
    line-height: 22px;
    position: absolute;
    top: 24px;
    left: 28px;
    cursor: pointer;
  }
  .return-title:hover{
    color: #4499FF;
  }
  .return-title:focus {
    color: #4499FF;
  }
  .login-title {
    font-size: 24px;
    font-weight: 600;
    // color: $--color-text-primary;
    line-height: 32px;
    text-align: center;
    color: #1F1F1F;
  }
  .relate-title{
    font-size: 24px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 300;
    color: #1F1F1F;
    line-height: 1;
    margin-top: 48px;
    margin-left: 48px;
    p{
      margin: 0;
      line-height: 32px;
    }
    i{
      font-size: 24px;
      cursor: pointer;
      color: rgba(31, 31, 31, 0.55);
    }
    span{
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: rgba(31, 31, 31, 0.55);
      line-height: 24px;
    }
  }
  .content{
    margin-top: 20px;
    height: 320px;
    overflow-x: auto;
    .content-item{
      &:first-child{
        margin-top: 0;
      }
      &:hover{
        border: 1px solid #4499FF;
      }
      height: 66px;
      border-radius: 4px;
      border: 1px solid rgba(33,37,48,.15);
      box-sizing: border-box;
      margin-top: 12px;
      display: flex;
      .item-left{
        display: flex;
        align-items: center;
        justify-content: center;
        width: 40px;
        margin: 12px;
        border-radius: 50%;
        background: #4499FF;
        color: #fff;
        .iconfont{
          display: inline-block;
          font-size: 24px;
        }
        &.person{
          background: #23BC8D;
        }
      }
      .item-middle{
        flex: 1;
        padding-right: 12px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        .item-title{
          font-size: 14px;
          color: #212530;
          line-height: 22px;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
        .item-account{
          font-size: 12px;
          color: rgba(33,37,48,.55);
          line-height: 20px;
        }

      }
      .item-right{
        width: 56px;
        padding-left: 12px;
        padding-right: 12px;
        .el-button{
          background: #4499FF;
          border-radius: 4px;
          padding-left: 14px;
          padding-right: 14px;
          border:none !important;
          &:hover{
            background-color: #2288ff !important;
          }
          &:active{
            background-color: #0f71e4 !important;
          }
        }
      }
    }
  }
  .unrelate-title{
    padding: 88px 84px 0;
    .common-txt{
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(31, 31, 31, 0.8);
      line-height: 36px;
      text-align: center;
    }
    .common-button-box{
      margin-top: 60px;
      display: flex;
      flex-direction: column;
      .registButton{
        font-size: 16px !important;
        background: #4499FF !important;
        &:hover{
          background: #2288FF !important;
        }
        &:active{
          background: #0F71E4 !important;
        }
      }
      .common-button{
        margin-left: 0;
        margin-top: 24px;
        font-size: 16px !important;
        &:hover{
          color: rgba(31, 31, 31, 0.8) !important;
          background: rgba(68, 153, 255, 0.15) !important;
        }
        &:active{
          color: rgba(31, 31, 31, 0.8) !important;
          background: rgba(68, 153, 255, 0.3) !important;
        }
      }
    }
  }
  ::v-deep .el-tabs__header{
       margin-bottom: 20px;
  }
  .userIcon{
    width: 14px;
    height: 15px;
    fill: currentColor;
    vertical-align: middle;
    margin-top: -3px;
  }
  ::v-deep .el-scrollbar__bar{
    right: -46px;
  }
}
.register-success-box-card{
  width: 260px;
  height: 320px !important;
  min-height: 320px !important;
  position: absolute;
  transform: translate(-50%, -50%);
  z-index: 103;
  .register-success-title{
    margin-top:10px;
    height: 92px;
    margin: auto;
    text-align: center;
    .register-success-icon{
      font-size: 14px;
      font-weight: 400;
      color: rgba(31,31,31,0.8);
      line-height: 22px;
      margin-bottom: 26px;
    }
  }
  .register-success-login{
    width: 88px;
    margin: 28px auto;
  }
}
.relateAccountBox{
  padding: 0 !important;
  .content{
    height: 390px;
    padding: 0 32px !important;
  }
}
.infoBlock {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  .icon {
    font-size: 24px;
    margin-right: 8px;
    // color: $--color-primary;
  }
  .content {
    // color: $--color-text-regular;
    .explain-content {
      text-indent: 30px;
    }
  }
  .info-down-middle {
    // color: $--color-primary;
    cursor: pointer;
  }
}
.el-icon-view,
.iconfont {
  font-size: 16px;
  cursor: pointer;
}
.el-icon-download {
  margin-right: 5px;
}
.dropdown-download {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  .icon-btn {
    width: 32px;
    height: 32px;
    border-radius: 16px;
    // background-color: $--color-info-1;
    // color: $--color-primary;
    font-size: 16px;
    text-align: center;
    padding: 3px 0 0 5px;
    margin-top: 4px;
  }
  .title-block {
    margin-left: 16px;
    .title,
    .info {
      height: 20px;
      line-height: 20px;
      .bentley {
        padding-right: 5px;
      }
      .revit {
        padding-left: 5px;
      }
    }
    .title {
      // color: $--color-text-primary;
      font-size: 14px;
    }
    .info {
      // color: $--color-primary;
      font-size: 12px;
    }
    .qrcode {
      // color: $--color-text-secondary;
    }
    .QRCode-img {
      width: 128px;
      height: 128px;
      margin-top: 10px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
.captchInfo-btn {
    width: 102px;
    padding: 0 8px !important;
    font-size: 16px;
    color:rgba(31, 31, 31, 0.8);
    &.is-disabled{
      color: #1f1f1f8c;
      border: 1px solid rgb(217, 217, 217) !important;
    }
    &:not(.is-disabled):hover{
      color: #4499FF !important;
      border: 1px solid #4499FF !important;
      background: rgba(68, 153, 255, 0.15) !important;
    }
    &:not(.is-disabled):active{
      color: #4499FF !important;
      border: 1px solid #4499FF !important;
      background: rgba(68, 153, 255, 0.3) !important;
    }
}
.download-source--popper {
  width: 240px;
  height: 324px;
  padding: 16px 0 0 0px;
}
.el-divider--horizontal {
  margin: 13px 0px !important;
}
.box-card-wrap {
  position: absolute;
  top: 250px;
  bottom: 250px;
  left: 236px;
  right: 236px;
}
.form-account-item {
  ::v-deep .el-form-item__error{
    left: 87px;
  }
  .form-account-item-info{
    font-size: 12px;
    line-height: 1;
    padding-top: 4px;
    position: absolute;
    top: 44px;
    left: 87px;
    font-weight: 400;
    color: rgba(31,31,31,0.55);
  }
  .form-account-item-error{
    font-size: 12px;
    line-height: 1;
    padding-top: 4px;
    position: absolute;
    top: 44px;
    left: 87px;
    font-weight: 400;
    color: #fa2a31;
  }
}
.form-text-item-error{
    font-size: 12px;
    line-height: 1;
    padding-top: 4px;
    position: absolute;
    top: 44px;
    left: 0px;
    font-weight: 400;
    color: #fa2a31;
  }
.form-mobile-item {
  .form-mobile-item-info{
    font-size: 12px;
    line-height: 1;
    padding-top: 4px;
    position: absolute;
    top: 44px;
    font-weight: 400;
    .form-mobile-item-text{
     color: #fa2a31;
   }
  .form-mobile-item-login{
     color: #2288ff;
     cursor: pointer;
    }
  }
}
.registerChecked{
  font-size: 14px;
  font-weight: 400;
  color: rgba(31,31,31,0.8);
  line-height: 22px;
}
@media (max-width: 600px) {
  .box-card-wrap {
    left: 50%;
    ::v-deep .el-card {
    min-height: 475px;
    padding: 32px 20px 33px 20px;
  }
  }
  .box-card {
   width: 335px;
   .el-tabs{
    padding: 0px !important;
   }
   .login-btn {
    // width: 293px;
    width: 285px;
    margin-bottom: 10px !important;
  }
  }
  .official-website{
    right: 20px !important;
  }
}
@media (max-height: 726px) {
.scrollbarClass{
  height: 407px;
}
.scrollbarTabsClass{
  height:392px !important;
}
}
</style>
<style>
  .itemPopoverClass{
    padding: 5px 12px !important;
  }
</style>
